/**
 * ADs
 */

const ADs = {
	/**
	 * Initializer
	 */
	init() {
		this.pageSkinAds();
	},

	/**
	 * pageSkinAds
	 */
	pageSkinAds() {
		const pageSkinAdsPosition = () => {
			this.breakpoint = window.matchMedia( '(max-width: 1850px)' );

			if ( this.breakpoint.matches ) {
				return;
			}
			const pageSkinAds = document.querySelector( '.js-pageskin-ads' );

			if ( pageSkinAds ) {
				const page = document.querySelector( '#content > .wrapper' );
				const leftAd = pageSkinAds.querySelector( '.page-skin-ad--left' );
				const rightAd = pageSkinAds.querySelector( '.page-skin-ad--right' );

				if ( page && ( leftAd || rightAd ) ) {
					const pageRect = page.getBoundingClientRect();
					const screenWidth = window.innerWidth;
					let pageWidth = pageRect.width;
					const leftOffset = 20;
					let rightOffset = 20;

					const sideWidth = ( screenWidth - pageWidth ) / 2;
					const adWidth = 160;

					let leftAdOffset = sideWidth - adWidth - leftOffset;
					let rightAdOffset = sideWidth - adWidth - rightOffset;

					if ( leftAdOffset < 0 ) {
						leftAdOffset = 0;
					}

					if ( rightAdOffset < 0 ) {
						rightAdOffset = 0;
					}

					let topPosition = pageRect.top > 0 ? pageRect.top : 50;

					if ( document.body.classList.contains('admin-bar') ) {
						topPosition += 32;
					}

					pageSkinAds.style.top = `${ topPosition }px`;

					if ( leftAd ) {
						leftAd.style.left = `${ leftAdOffset }px`;
					}

					if ( rightAd ) {
						rightAd.style.right = `${ rightAdOffset }px`;
					}

					pageSkinAds.classList.add( 'show' );
				}
			}
		};

		pageSkinAdsPosition();

		window.addEventListener( 'jumpPoints:added', () => {
			pageSkinAdsPosition();
		} );
		document.addEventListener( 'scroll', pageSkinAdsPosition );

		let debounce;
		window.addEventListener('resize', () => {
			clearTimeout(debounce);

			debounce = setTimeout(() => {
				pageSkinAdsPosition();
			}, 500);
		});
	},
};

export default ADs;
